import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { TeamReportServiceService } from '../team-report/team-report-service.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-orgs-individual',
  templateUrl: './orgs-individual.component.html',
  styleUrls: ['./orgs-individual.component.scss']
})
export class OrgsIndividualComponent implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();
	id:number;
    teamWizard:boolean;
    org_name:string;
    getOptions:boolean;
    teams:any;
    sessions:any;
    orgData:any;

  	constructor(public activatedRoute:ActivatedRoute, public http: HttpClient, public modalService:NgbModal, public route: Router, private teamService: TeamReportServiceService) { }

  	ngOnInit() {
  		this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(async (params: Params) => {
        this.id = params.id;
        this.teamWizard = false;
        this.getOptions = false;
        this.org_name = localStorage.getItem("currentOrgName");
      })
  	}

    public back() {
      window.history.back();
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

}
